export const invData = [
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "NLADBU",
    startDate: 1721593800,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "90",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5185,
            station_id: 21274,
            order: 45,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "AVDSSX",
    startDate: 1721593800,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 9,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "72",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 1,
          },
        },
        {
          id: 20864,
          code: "2075",
          title: "پایانه زاینده رود",
          subtitle: null,
          zone_id: 5627,
          type: "bus",
          lat: 32.632456,
          lng: 51.626242,
          address: "پایانه زاینده رود",
          created_at: null,
          updated_at: "2024-04-24T12:16:21.000000Z",
          pivot: {
            path_id: 5184,
            station_id: 20864,
            order: 32,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "VESQMX",
    startDate: 1721593800,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "61",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 1,
          },
        },
        {
          id: 20404,
          code: "1554",
          title: "میدان آزادی",
          subtitle: null,
          zone_id: 5218,
          type: "bus",
          lat: 32.618544,
          lng: 51.663815,
          address: "میدان آزادی",
          created_at: null,
          updated_at: "2024-04-24T12:18:02.000000Z",
          pivot: {
            path_id: 5183,
            station_id: 20404,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JMWTZR",
    startDate: 1721593800,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "39",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22065,
          code: "3416",
          title: "گل ها",
          subtitle: null,
          zone_id: 5249,
          type: "bus",
          lat: 32.616009,
          lng: 51.602923,
          address: "گل ها",
          created_at: null,
          updated_at: "2024-04-24T12:12:14.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 22065,
            order: 1,
          },
        },
        {
          id: 21913,
          code: "3247",
          title: "میدان نهم دی",
          subtitle: null,
          zone_id: 5251,
          type: "bus",
          lat: 32.617192,
          lng: 51.60231,
          address: "میدان نهم دی",
          created_at: null,
          updated_at: "2024-04-24T12:12:48.000000Z",
          pivot: {
            path_id: 5182,
            station_id: 21913,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "UAIQOU",
    startDate: 1721593800,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 4,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21275,
          code: "2524",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5211,
          type: "bus",
          lat: 32.640423,
          lng: 51.697617,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 21275,
            order: 1,
          },
        },
        {
          id: 22676,
          code: "4182",
          title: "اسپارت",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.533769,
          lng: 51.893192,
          address: "اسپارت",
          created_at: null,
          updated_at: "2024-04-24T12:09:56.000000Z",
          pivot: {
            path_id: 5181,
            station_id: 22676,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "HWILNH",
    startDate: 1721593800,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "641",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20934,
          code: "2156",
          title: "سه راهی باچه",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.552669,
          lng: 51.880486,
          address: "سه راهی باچه",
          created_at: null,
          updated_at: "2024-04-24T12:16:10.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 20934,
            order: 2,
          },
        },
        {
          id: 21274,
          code: "2523",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5210,
          type: "bus",
          lat: 32.640748,
          lng: 51.69636,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:15:07.000000Z",
          pivot: {
            path_id: 5180,
            station_id: 21274,
            order: 30,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "YXEMDB",
    startDate: 1721680200,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22338,
          code: "3717",
          title: "کوی قائم",
          subtitle: null,
          zone_id: 5329,
          type: "bus",
          lat: 32.637728,
          lng: 51.768563,
          address: "کوی قائم",
          created_at: null,
          updated_at: "2024-04-24T12:11:16.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 22338,
            order: 4,
          },
        },
        {
          id: 20895,
          code: "2116",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.5231,
          lng: 52.035428,
          address: "برسیان",
          created_at: null,
          updated_at: "2024-04-24T12:16:17.000000Z",
          pivot: {
            path_id: 5179,
            station_id: 20895,
            order: 24,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "EWUSFV",
    startDate: 1721680200,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "481",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22713,
          code: "210145016",
          title: "برسیان",
          subtitle: null,
          zone_id: 5366,
          type: "bus",
          lat: 32.039777,
          lng: 51.874553,
          address: "اصفهان، شهرضا، سیف اله حیدرپور",
          created_at: "2024-07-07T07:41:19.000000Z",
          updated_at: "2024-07-07T07:46:24.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 22713,
            order: 1,
          },
        },
        {
          id: 21591,
          code: "2870",
          title: "پایانه شهدای ارغوانیه",
          subtitle: null,
          zone_id: 5330,
          type: "bus",
          lat: 32.645564,
          lng: 51.783791,
          address: "پایانه شهدای ارغوانیه",
          created_at: null,
          updated_at: "2024-04-24T12:14:01.000000Z",
          pivot: {
            path_id: 5178,
            station_id: 21591,
            order: 41,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JCZSFM",
    startDate: 1721680200,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20568,
            order: 1,
          },
        },
        {
          id: 20120,
          code: "1226",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5669,
          type: "bus",
          lat: 32.640002,
          lng: 51.692765,
          address: "میدان بزرگمهر",
          created_at: null,
          updated_at: "2024-04-24T12:18:56.000000Z",
          pivot: {
            path_id: 5175,
            station_id: 20120,
            order: 17,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GNVPPE",
    startDate: 1721680200,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "291",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22714,
          code: "120027",
          title: "میدان بزرگمهر",
          subtitle: null,
          zone_id: 5321,
          type: "bus",
          lat: 32.727253,
          lng: 51.700973,
          address: "اصفهان، اصفهان، منطقه ۷، شهدا ورزی، بلوار بعثت، محسنی",
          created_at: "2024-07-07T08:06:34.000000Z",
          updated_at: "2024-07-07T08:06:37.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 22714,
            order: 1,
          },
        },
        {
          id: 20568,
          code: "1766",
          title: "میدان امام علی ع",
          subtitle: null,
          zone_id: 5177,
          type: "bus",
          lat: 32.667533,
          lng: 51.686932,
          address: "میدان امام علی ع",
          created_at: null,
          updated_at: "2024-04-24T12:17:25.000000Z",
          pivot: {
            path_id: 5174,
            station_id: 20568,
            order: 12,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "IVJUSD",
    startDate: 1721680200,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 2,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "269B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5173,
            station_id: 22672,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BZLGUP",
    startDate: 1721680200,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "267B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 22493,
          code: "3958",
          title: "نقلیه",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.720006,
          lng: 51.534805,
          address: "نقلیه",
          created_at: null,
          updated_at: "2024-04-24T12:10:40.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22493,
            order: 1,
          },
        },
        {
          id: 22672,
          code: "4175",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:09:58.000000Z",
          pivot: {
            path_id: 5171,
            station_id: 22672,
            order: 22,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "BEYBHC",
    startDate: 1721766600,
    startTime: 50400,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9195504474,
      melliCode: "5459073669",
      idNumber: "out-3669",
      name: "\u0645\u0646\u0635\u0648\u0631 \u0646\u0635\u06cc\u0631\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21952,
          code: "3287",
          title: "دانشگاه اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549846,
          lng: 51.685577,
          address: "دانشگاه اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:40.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21952,
            order: 1,
          },
        },
        {
          id: 21981,
          code: "3321",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.556988,
          lng: 51.680267,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:35.000000Z",
          pivot: {
            path_id: 5169,
            station_id: 21981,
            order: 21,
          },
        },
      ],
    },
    car: {
      code: "VFV035",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-353-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MPFQRT",
    startDate: 1721766600,
    startTime: 51300,
    estimateTime: 4200,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 10,
    driver: {
      mobile: 9944762906,
      melliCode: "0790973359",
      idNumber: "out-3359",
      name: "\u0627\u062d\u0645\u062f \u0642\u0644\u0639\u0647 \u0646\u0648\u06cc\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "176",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21987,
          code: "3327",
          title: "بلوار قائم",
          subtitle: null,
          zone_id: 5348,
          type: "bus",
          lat: 32.557149,
          lng: 51.679897,
          address: "بلوار قائم",
          created_at: null,
          updated_at: "2024-04-24T12:12:34.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 21987,
            order: 1,
          },
        },
        {
          id: 22023,
          code: "3365",
          title: "دانشگاه شهید اشرفی اصفهانی",
          subtitle: null,
          zone_id: 5346,
          type: "bus",
          lat: 32.549795,
          lng: 51.685097,
          address: "دانشگاه شهید اشرفی اصفهانی",
          created_at: null,
          updated_at: "2024-04-24T12:12:24.000000Z",
          pivot: {
            path_id: 5168,
            station_id: 22023,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV037",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-359-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "SYBABJ",
    startDate: 1721766600,
    startTime: 52200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 12,
    driver: {
      mobile: 9368622686,
      melliCode: "0033020159",
      idNumber: "out-0159",
      name: "\u0645\u062d\u0645\u062f \u0631\u0636\u0627 \u0686\u0645\u0646 \u0633\u0631\u0627",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 21116,
            order: 1,
          },
        },
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5167,
            station_id: 20946,
            order: 19,
          },
        },
      ],
    },
    car: {
      code: "VFV075",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-412-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "JPAOZA",
    startDate: 1721766600,
    startTime: 59400,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 6,
    driver: {
      mobile: 9357412435,
      melliCode: "2298991588",
      idNumber: "out-1588",
      name: "\u067e\u06cc\u0645\u0627\u0646 \u0628\u062f\u06cc\u0639\u06cc",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "169",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 20946,
          code: "2168",
          title: "پایانه مترو قدس",
          subtitle: null,
          zone_id: 5311,
          type: "bus",
          lat: 32.714914,
          lng: 51.601993,
          address: "پایانه مترو قدس",
          created_at: null,
          updated_at: "2024-04-24T12:16:08.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 20946,
            order: 1,
          },
        },
        {
          id: 21116,
          code: "2359",
          title: "میدان فولاد",
          subtitle: null,
          zone_id: 5352,
          type: "bus",
          lat: 32.716135,
          lng: 51.51714,
          address: "میدان فولاد",
          created_at: null,
          updated_at: "2024-04-24T12:15:38.000000Z",
          pivot: {
            path_id: 5166,
            station_id: 21116,
            order: 20,
          },
        },
      ],
    },
    car: {
      code: "VFV044",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "62-\u062a-332-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "GJTDWP",
    startDate: 1721766600,
    startTime: 61200,
    estimateTime: 3600,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 5,
    driver: {
      mobile: 9198259892,
      melliCode: "0046688889",
      idNumber: "out-8889",
      name: "\u062f\u0627\u0648\u0648\u062f \u0647\u0627\u0634\u0645\u06cc \u0632\u0627\u062f",
      freelancer: "offline",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157B",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21840,
            order: 1,
          },
        },
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5165,
            station_id: 21837,
            order: 7,
          },
        },
      ],
    },
    car: {
      code: "VFV008",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-835-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
  {
    code: "MOTWFN",
    startDate: 1721766600,
    startTime: 63600,
    estimateTime: 4500,
    price: 41040,
    realPrice: 54720,
    momentaryPrice: 54720,
    weekPrice: 46512,
    minType: "percent",
    minValue: 0,
    monthPrice: 41040,
    capacity: 12,
    remaining: 0,
    driver: {
      mobile: 9228347797,
      melliCode: "0061970141",
      idNumber: "int-7797",
      name: " \u062d\u062c\u062a \u0628\u0627\u0642\u0631\u06cc ",
      freelancer: "online",
    },
    salePermit: 1,
    salePermitDesc: null,
    path: {
      code: "157",
      title: "\u0648\u0646\u06a9 \u0628\u0647 \u062a\u0647\u0631\u0627\u0646\u0633\u0631",
      type: "innercity",
      stations: [
        {
          id: 21837,
          code: "3165",
          title: "انتهای شهرک امام حسین ع",
          subtitle: null,
          zone_id: 5576,
          type: "bus",
          lat: 32.719101,
          lng: 51.739121,
          address: "انتهای شهرک امام حسین ع",
          created_at: null,
          updated_at: "2024-04-24T12:13:06.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21837,
            order: 1,
          },
        },
        {
          id: 21840,
          code: "3168",
          title: "دارک",
          subtitle: null,
          zone_id: 5574,
          type: "bus",
          lat: 32.720382,
          lng: 51.732016,
          address: "دارک",
          created_at: null,
          updated_at: "2024-04-24T12:13:04.000000Z",
          pivot: {
            path_id: 5164,
            station_id: 21840,
            order: 6,
          },
        },
      ],
    },
    car: {
      code: "VFV042",
      type: "van",
      color: "\u0632\u0631\u062f",
      plaque: "61-\u062a-584-11",
      buildYear: 1401,
      chairNumber: 12,
    },
  },
];

// {
//   code: "ACTUGP",*
//   plan: "UA5VJM",
//   path: "641",*
//   driver: 329,
//   car: "VFM047",
//   startDate: 1656099000,*
//   startTime: 24600,*
//   estimateTime: 4800,*
//   price: 1,
//   realPrice: 1,
//   status: "expired",*
// }
